// extracted by mini-css-extract-plugin
export var content = "article-module--content--e3f90 text-content-without-margin-module--wrapper--cae57";
export var wrapper = "article-module--wrapper--6934e container-module--wrapper--c1517";